import CalenderContainer from "../../../Components/Application/Calender/Calender"

const Calender = () => {
  return (
    <div className='page-body'>
      <CalenderContainer />
    </div>
  )
}

export default Calender